<div class="container p-5" *ngIf="!selectedCampaign">
    <div class="row">
        <h1 class="mb-1">Create a campaign</h1>
        <h4 class="mb-0">Schedule a call to customer by using an excel file</h4>
    </div>
    <div class="row">
        <div class="col-12 d-flex justify-content-end">
            <button mat-raised-button (click)="onAddCampaign()">
                <mat-icon>add</mat-icon>
                Add Campaign
            </button>
        </div>
    </div>

    <!-- Filter -->
    <div class="row">
        <div class="col-12">
            <mat-form-field appearance="fill" class="w-100 mt-5">
                <mat-label>Filter By name</mat-label>
                <input matInput  (keyup)="applyFilter($event)" placeholder="Ex. Mia" #input>
                <mat-icon matPrefix>search</mat-icon>
            </mat-form-field>
        </div>
    </div>

    <div class="row">
        <div class="col-4 mt-2" *ngFor="let x of filteredCampaigns;let i = index">
            <div class="mat-elevation-z2 justify-content-around align-items-center rounded p-3">
                <div class="container">
                    <div class="row">
                        <p class="fw-bold text-decoration-underline text-center">{{x.name}}</p>
                        <p class="text-center">{{x.status}}</p>
                    </div>
                    
                    <div class="row">
                        <p>Scheduled for: {{x.date}} at {{x.time}} </p>
                    </div>
                    <div class="row mt-2 mb-2">
                        <button class="w-100" mat-raised-button (click)="onViewSelectedCampaign(x.id)" >
                            <span>View</span>
                        </button>
                    </div>
                    <div class="row mt-2 mb-2">
                        <button color="warn w-75" [disabled]="isLoadingArray[i]" (click)="onDeleteCampaign(x.id,i)"
                            class="w-100" mat-raised-button>
                            <span *ngIf="!isLoadingArray[i]">Remove</span>

                            <mat-spinner *ngIf="isLoadingArray[i]" [diameter]="30" [strokeWidth]="3"
                                class="mx-auto mat-spinner"></mat-spinner>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container p-5 h-100" *ngIf="selectedCampaign">
    <app-call-log-list *ngIf="!currentCallLog" [isCampaignReview]="true" [callLogResponses]="selectedCampaign.callLogs"></app-call-log-list>
    <app-call-log-view *ngIf="currentCallLog" [callLog]="currentCallLog!"></app-call-log-view>
</div>